import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { renderComponentField } from '@/shared/components/form/FormField';

const Option = (props) => {
  const { data, isFocused } = props;

  return (
    <components.Option {...props}>
      <div className="select-option">
        <div className="select-option__label">
          {data.label}
        </div>

        {isFocused && data.description && (
          <div
            className="select-option__description"
            style={{
              color: '#555',
              marginTop: 4,
              display: 'block',
              border: '1px solid #ccc',
              backgroundColor: '#f8fafcff',
              padding: '4px 6px',
              borderRadius: '3px'
            }}
          >
            {data.description}
          </div>
        )}
      </div>
    </components.Option>
  );
};

export const SelectField = React.forwardRef(({
  onChange, customOnChange, value, name, placeholder, options, isClearable
}, ref) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
    // External custom change
    if (customOnChange) {
      customOnChange(selectedOption);
    }
  };

  return (
    <Select
      name={name}
      value={value}
      onChange={handleChange}
      options={options}
      clearable={false}
      className="react-select"
      placeholder={placeholder}
      classNamePrefix="react-select"
      ref={ref}
      isClearable={isClearable}
      components={{ Option }}
    />
  );
});

SelectField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]).isRequired,
};

SelectField.defaultProps = {
  placeholder: '',
  options: [],
};

export default renderComponentField(SelectField);
